const categories = {
    'clothing': ['shirts', 'pants', 'jackets', 'swimwears'],
    'shoes': ['fashion-shoes', 'elegant-shoes', 'sports-shoes'],
    'jewelry': ['rings', 'necklaces', 'bracelets', 'earrings', 'watches'],
    'accessories': ['sunglasses', 'hats', 'bags']
}

export default categories;